module.exports = __webpack_public_path__ + "img/fontumi-cellphone.94b6da6d.png";